import React from "react";
import { Button, Card, CardContent } from "@mhome/ui";

const ClosePage = () => {
  const handleClose = () => {
    window.close();
  };

  return (
    <div className="flex h-screen items-center justify-center">
      <Card className="w-full max-w-[400px] rounded-2xl border bg-card shadow-sm">
        <CardContent className="flex flex-col items-center p-8">
          <Button
            variant="default"
            onClick={handleClose}
            fullWidth
            className="rounded-full"
          >
            Close
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClosePage;
